/* ==========================================================================
   diXed · Lupe auf der Produktseite
   Angelegt 31.08.2026 auf Ronnys Wunsch, Verhalten wie bei Amazon.

   Beim Zeigen auf das Hauptbild erscheint ein Ausschnittfenster auf dem Bild
   und rechts daneben eine Tafel mit der Vergroesserung. Die Tafel legt sich
   ueber die Kaufspalte, genau wie bei Amazon.

   Drei bewusste Entscheidungen:
   1. Nur bei echtem Zeigegeraet und ab 990 px. Auf dem Handy bleibt der
      vorhandene Lichtkasten, den ein Antippen oeffnet.
   2. Das aktive Bild wird bei JEDEM Zeigen neu gesucht, nicht einmal beim
      Laden. Der Kunde wechselt Farbe und Miniatur, und dann ist ein einmal
      gemerktes Bild falsch.
   3. Kein requestAnimationFrame und keine Uebergaenge. Die Tafel folgt der
      Maus direkt. Im Vorschau-Fenster laufen Animationen ohnehin nicht ab,
      und eine Lupe, die nachzieht, waere schlechter als eine, die steht.
   ========================================================================== */

(function () {
  'use strict';

  var VERGROESSERUNG = 2.6;
  var MINDESTBREITE = 990;

  function zeigegeraetDa() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches
      && window.innerWidth >= MINDESTBREITE;
  }

  /* Shopify liefert Bilder ueber einen Groessenparameter aus. Fuer die Lupe
     wird eine hoehere Stufe geholt, sonst vergroessert man Unschaerfe. */
  function grosseQuelle(img) {
    var u = img.currentSrc || img.src || '';
    if (!u) return '';
    if (u.indexOf('width=') === -1) return u;
    return u.replace(/([?&])width=\d+/, '$1width=1946');
  }

  function aktivesBild(galerie) {
    var aktiv = galerie.querySelector('.product__media-item.is-active img')
      || galerie.querySelector('.product__media-item:not([style*="display: none"]) img')
      || galerie.querySelector('.product__media img');
    return aktiv;
  }

  function aufbauen(wrapper) {
    var galerie = wrapper.querySelector('media-gallery');
    if (!galerie) return;

    var feld = document.createElement('div');
    feld.className = 'dx-lupe-feld';
    var tafel = document.createElement('div');
    tafel.className = 'dx-lupe-tafel';
    wrapper.appendChild(feld);
    wrapper.appendChild(tafel);

    /* Der Wrapper braucht einen Bezugspunkt, sonst haengen die beiden
       absolut gesetzten Kaesten am naechsten positionierten Vorfahren. */
    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    var bild = null;
    var bildKasten = null;
    var wrapperKasten = null;
    var tafelBreite = 0;
    var tafelHoehe = 0;

    function beginnen(e) {
      if (!zeigegeraetDa()) return;
      bild = aktivesBild(galerie);
      if (!bild || !bild.naturalWidth) return;

      bildKasten = bild.getBoundingClientRect();
      wrapperKasten = wrapper.getBoundingClientRect();

      /* Die Tafel ist so hoch wie das Bild und nutzt den Platz rechts davon
         bis zum rechten Rand der Kaufspalte. */
      var rechtsVomBild = bildKasten.right - wrapperKasten.left + 16;
      tafelHoehe = bildKasten.height;
      tafelBreite = Math.min(620, Math.max(360, window.innerWidth * 0.34));

      tafel.style.left = rechtsVomBild + 'px';
      tafel.style.top = (bildKasten.top - wrapperKasten.top) + 'px';
      tafel.style.width = tafelBreite + 'px';
      tafel.style.height = tafelHoehe + 'px';
      tafel.style.backgroundImage = 'url("' + grosseQuelle(bild) + '")';
      tafel.style.backgroundSize =
        (bildKasten.width * VERGROESSERUNG) + 'px ' +
        (bildKasten.height * VERGROESSERUNG) + 'px';

      /* Das Ausschnittfenster ist genau der Bereich, den die Tafel zeigt. */
      feld.style.width = (tafelBreite / VERGROESSERUNG) + 'px';
      feld.style.height = (tafelHoehe / VERGROESSERUNG) + 'px';

      wrapper.classList.add('dx-lupe-an');
      bewegen(e);
    }

    function bewegen(e) {
      if (!bild || !wrapper.classList.contains('dx-lupe-an')) return;

      var feldBreite = feld.offsetWidth;
      var feldHoehe = feld.offsetHeight;

      /* Position der Maus im Bild, dann das Fenster mittig darum, aber
         niemals ueber den Bildrand hinaus. */
      var x = e.clientX - bildKasten.left - feldBreite / 2;
      var y = e.clientY - bildKasten.top - feldHoehe / 2;
      x = Math.max(0, Math.min(x, bildKasten.width - feldBreite));
      y = Math.max(0, Math.min(y, bildKasten.height - feldHoehe));

      feld.style.left = (bildKasten.left - wrapperKasten.left + x) + 'px';
      feld.style.top = (bildKasten.top - wrapperKasten.top + y) + 'px';

      tafel.style.backgroundPosition =
        (-x * VERGROESSERUNG) + 'px ' + (-y * VERGROESSERUNG) + 'px';
    }

    function beenden() {
      wrapper.classList.remove('dx-lupe-an');
      bild = null;
    }

    galerie.addEventListener('mouseenter', beginnen, true);
    galerie.addEventListener('mousemove', bewegen);
    galerie.addEventListener('mouseleave', beenden);
    window.addEventListener('scroll', beenden, { passive: true });
    window.addEventListener('resize', beenden);
  }

  function start() {
    document.querySelectorAll('.product__media-wrapper').forEach(aufbauen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
